exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fm-additions-file-list .far {\n  padding-right: 0.5rem;\n}", ""]);

// exports
